import React from 'react';
import { useSnapshot } from 'valtio';
import { state } from '../store/global';
import { Navigate } from 'react-router-dom';

export default function AuthenticatedRoute({ children }) {
  const snap = useSnapshot(state);
  console.log('isAuthenticated: ', snap.isAuthenticated);

  // Redirect if not authenticated
  if (!snap.isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Allow access
  return children;
}
